import axios from "axios";

const getByDate = (date) => {
  return axios
    .get(`/mawb/${date}/all`)
    .then(response => response)
    .catch(error => {
      throw error;
    });
}

const getArrivalsDate = () => {
  return axios
    .get(`/mawb/arrivalsDate`)
    .then(response => response)
    .catch(error => {
      throw error;
    });
}

const searchMAWB = (text) => {
  return axios
  .get(`mawb/search/${text}`)
  .then(response => response)
  .catch(error => {
    throw error
  })
}

const infoLink = (customerID, mawbID) => {
  return axios.post('infolink', {
    customerID: customerID,
    mawbID: mawbID
  })
  .then(response => response)
  .catch(error => {
    throw error
  })
}

export {
  getByDate,
  getArrivalsDate,
  searchMAWB,
  infoLink
}
